/**
 * Double-Opt-In Status einer Geburtstagsbuchung
 */
export enum MailingRecipientStatus {
    /**
     * Angemeldet, aber noch nicht auf Bestätigungslink geklickt.
     */
    confirmationPending = "confirmationPending",

    /**
     * Angemeldet und E-Mail Adresse bestätigt.
     */
    confirmed = "confirmed",

    /**
     * Angemeldet und E-Mail Adresse bestätigt, aber Newsletter nicht zustellbar.
     */
    unreachable = "unreachable"
}

export const MailingRecipientStatusNames = {
    confirmationPending: "Bestätigung abwarten",
    confirmed: "Bestätigt und aktiv",
    unreachable: "Nicht zustellbar"
};
